var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPj4OnShipping = function SvgPj4OnShipping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Pj4OnShipping_svg__a)",
    stroke: "current",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.833 34.833a3.667 3.667 0 1 0 0-7.333 3.667 3.667 0 0 0 0 7.333ZM31.167 34.833a3.667 3.667 0 1 0 0-7.333 3.667 3.667 0 0 0 0 7.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.167 31.167H5.5V11a1.833 1.833 0 0 1 1.833-1.833h16.5v22m-7.333 0h11m7.333 0H38.5v-11m0 0H23.833m14.667 0L33 11h-9.167"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Pj4OnShipping_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v44H0z"
  })))));
};

export default SvgPj4OnShipping;